import { X } from 'lucide-react';

import { Button } from '@/ui/base/button';
import { cn } from '@/nucleo/utilitarios';

interface ClearFiltersButtonProps {
  /** So aparece quando ha filtro ativo (docs/DESIGN-SYSTEM.md, secao 5). */
  active: boolean;
  /** Quantidade de filtros ativos, mostrada entre parenteses. */
  count?: number;
  onClear: () => void;
  className?: string;
}

/**
 * Limpa os filtros de uma busca. O que o usuario nao pode fazer nao e
 * renderizado (CLAUDE.md, "Regras de interface", item 7): sem filtro ativo, o
 * botao nao existe — nao fica desabilitado.
 */
export function ClearFiltersButton({ active, count, onClear, className }: ClearFiltersButtonProps) {
  if (!active) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={onClear}
      className={cn('gap-1 text-muted-foreground', className)}
    >
      <X className="h-4 w-4" aria-hidden="true" />
      {/*
        Rótulo como a referência aprovada escreve — "Limpar 1 filtro aplicado",
        não "Limpar filtros (1)". A contagem entre parênteses obrigava a ler o
        número solto; a frase diz o que o clique faz. Sem contagem, continua
        "Limpar filtros".
      */}
      <span>
        {count
          ? `Limpar ${count} ${count === 1 ? 'filtro aplicado' : 'filtros aplicados'}`
          : 'Limpar filtros'}
      </span>
    </Button>
  );
}
